import { render, staticRenderFns } from "./CustomPcNav.vue?vue&type=template&id=9a24d2cc&scoped=true&"
import script from "./CustomPcNav.vue?vue&type=script&lang=js&"
export * from "./CustomPcNav.vue?vue&type=script&lang=js&"
import style0 from "./CustomPcNav.vue?vue&type=style&index=0&id=9a24d2cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a24d2cc",
  null
  
)

export default component.exports